
import {CmonRequestServiceResponseData} from '../CmonRequestService';
import CmonError from './CmonError';

export default class CmonAuthRequiredError
    extends CmonError {

    constructor(jsonError: CmonRequestServiceResponseData) {
        super(jsonError);
    }

}
